import { Chip } from "@/components/core/Chip";

interface VoteHeaderProps {
    participantCount: number;
    hasVoted?: boolean;
}

/**
 * 투표 헤더 컴포넌트
 * "오늘의 투표" 배지와 참여자 수 표시
 */
export const VoteHeader: React.FC<VoteHeaderProps> = ({
    participantCount,
    hasVoted = false
}) => {
    return (
        <div className="my-3 flex items-center justify-between gap-2">
            {/* <div className="inline-flex items-center rounded-full bg-black px-3.5 py-1.5 text-xs font-bold text-white dark:bg-white dark:text-black">
                오늘의 투표
            </div> */}
            <Chip className="dark:border bg-gray-300 rounded-lg">밸런스 투표</Chip>
            {/* <div className="inline-flex items-center rounded-full border border-gray-200 bg-black px-3.5 py-1.5 text-xs font-bold text-white dark:border-gray-700 dark:bg-white dark:text-black">
                {hasVoted
                    ? `${participantCount}명 참여 · 내가 투표함`
                    : `${participantCount}명 참여`}
            </div> */}
        </div>
    );
};
